<template>
  <div
    class="entrance"
    v-loading="loading"
    element-loading-text="加载中,请稍后..."
  >
    <div class="cont">
      <div class="head-cont">
        <img class="head-pic" :src="data.cover" alt />
      </div>
      <div class="cont-msg">
        <h3 class="cont-title">
          {{ data.title }}
        </h3>
        <p>试题数量：{{ data.num }}题</p>
        <div v-if="data.type != 4">
          <p>试卷满分：{{ data.score }}分</p>
          <p>答题时间：{{ data.minutes }}分钟</p>
        </div>
        <div style="height:100px" v-if="data.type == 4"></div>
        <div v-if="data.type == 2">
          <p v-if="data.weekly != 0">
            考试开放时间：每周{{ data.weekly }} {{ data.weekly_time }}
          </p>
          <p class="start" v-if="data.weekly == 0">
            考试开放时间：{{ data.start_time }}
          </p>
          <p v-if="data.weekly == 0">考试关闭时间：{{ data.end_time }}</p>
        </div>

        <el-button
          :disabled="disabled"
          type="primary"
          round
          @click="toPay"
          v-show="payShow"
          >去支付</el-button
        >
        <div v-show="!payShow">
          <el-button
            :disabled="disabled"
            type="primary"
            round
            @click="toAnswer('exam')"
            v-if="!data.is_verify"
            >开始答题</el-button
          >
          <el-button
            :disabled="disabled"
            type="primary"
            round
            @click="logout"
            v-if="!data.is_verify"
            >退出考试</el-button
          >
          <el-button
            :disabled="disabled"
            type="primary"
            round
            @click="toAnswer('Takephoto', data.id)"
            v-if="data.is_verify"
            >认证答题</el-button
          >
          <el-button
            :disabled="disabled"
            type="primary"
            round
            @click="out"
            v-if="data.is_verify"
            >离开考试</el-button
          >
        </div>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="400px">
      <span>试卷已被关闭,请联系管理员!</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="考试须知"
      :visible.sync="dialogExam"
      width="800px"
      center
      @close="close"
    >
      <div class="examKnow">
        1.考生凭本人账号登录进入在线考试系统后，通过人脸识别确认考生本人身份后（无验证请忽略人脸验证），方可开始考试；<br />
        2.考试时，须全程保持人脸在人脸识别窗口范围内，且免冠正面面向屏幕（无AI智能监考请忽略本条）；<br />
        3.未提交答卷之前，不得离开考位； <br />
        4.考试过程中请勿随意讲话；<br />
        5.考试过程中，考生周边近距离内不得出现其他人员；<br />
        6.不得中途换他人替考；<br />
        7.不得使用虚拟摄像头、虚拟机；<br />
        8.不得拔掉摄像头；<br />
        9.不得用照片或录像替考； <br />
        10.不得外接显示器；<br />
        11.不得使用网络搜索和远程桌面控制；<br />
        12.不得做与考试无关的事情；<br />
        13.衣着不整者不得参加考试；<br />
        14.考生应认真独立答题，不得利用通讯工具与外界联系，不得与他人交谈；<br />
        15.若考生在考试途中违反考试规则，系统将自动没收试卷；<br />
      </div>
      <el-form
        :model="personalInfo"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <!-- <el-form-item label="考生姓名：" prop="name">
          <el-input
            v-model="personalInfo.name"
            placeholder="请输入考生姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号码：" prop="mobile">
          <el-input
            v-model="personalInfo.mobile"
            placeholder="请输入考生手机号码"
          ></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button
            type="primary"
            :disabled="diasbled_btn"
            @click="toVerify('Takephoto', data.id)"
            >{{ countdown }} 我已知晓并愿意遵守</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="dialogAccount" width="550px" center>
      <p>
        您输入的考生信息与登录的账号信息不一致，请核对一下信息，如机构不一致请重新登录，如账号信息不一致请核实信息并重新输入：
      </p>
      <p><b>账号信息：</b></p>
      <p class="mem_name">
        账号信息：{{ account.mem_name }} {{ account.mem_phone }}
      </p>
      <p>
        <b>您输入的考生信息：</b>
      </p>
      <p class="mem_name">
        考生信息：{{ personalInfo.name }} {{ personalInfo.mobile }}
      </p>
      <span slot="footer" class="dialog-footer">
        <div style="account">
          <el-button type="warning" @click="toLogin" style="margin-right:70px"
            >重新登录</el-button
          >
          <el-button type="primary" @click="clearInfo">重新输入</el-button>
        </div>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogSubmit"
      width="400px"
      center
      :close-on-click-modal="false"
      :show-close="false"
    >
      <p>
        检测到你有未提交的试卷，请立即提交！
      </p>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handlePaper">立即提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import $ from 'jquery'
export default {
  name: 'entrance',
  data() {
    return {
      data: {},
      personalInfo: {},
      loading: true,
      disabled: false,
      dialogVisible: false,
      is_repeat: 1,
      dialogExam: false,
      countdown: '5',
      timer: null,
      rules: [],
      diasbled_btn: true,
      dialogAccount: false,
      account: {},
      dialogSubmit: false,
      payShow: false,
      weeks: ['0', '一', '二', '三', '四', '五', '六', '七'],
    }
  },
  created() {
    this.toAnswer()
    if (
      this.Storage.getStorage(this.$route.params.id) &&
      this.Storage.getStorage(this.$route.params.id).exam.type == 2
    ) {
      let start_time = this.Storage.getStorage(this.$route.params.id).start_time
      let exam_time = this.Storage.getStorage(this.$route.params.id).exam_time
      let time = parseInt(new Date().getTime() / 1000)
      let time_late = exam_time - 20
      if (time - start_time < exam_time * 60) {
        if (time - start_time > time_late * 60) {
          this.dialogSubmit = true
        }
      }
    }
  },
  methods: {
    handlePaper() {
      let data = this.Storage.getStorage(this.$route.params.id)
      this.handlePaperData(data)
    },
    handlePaperData(data) {
      console.log(data)
      let option = [],
        ques = JSON.parse(JSON.stringify(data.ques))
      ques.forEach(item => {
        option.push({
          id: item.id,
          type: item.type,
          options: item.is_select,
        })

        item.options = JSON.stringify(item.options)
      })
      let exam = JSON.parse(JSON.stringify(this.data))
      exam.usedTime = this.useMinute * 60 + this.useSecond
      exam.question = JSON.stringify(option)
      let _this = this,
        id = this.$route.params.id
      this.$http
        .post(process.env.VUE_APP_URL + 'paper/paper', exam)
        .then(function(data) {
          _this.disabledBtn = false
          _this.loading = false
          if (data.data.code == 200) {
            _this.Storage.delStorage(id)
            _this.Storage.delStorage('timer')
            _this.Storage.delStorage('endTimer')
            _this.toAnswer()
            _this.dialogSubmit = false
          } else {
            _this.$message.error(data.data.msg)
          }
        })
        .catch(function(error) {
          _this.disabledBtn = false

          _this.$message.error({ message: '网络错误,请刷新界面重试' })
          return
        })
    },
    getRandomIntInclusive(min, max) {
      min = Math.ceil(min)
      max = Math.floor(max)
      this.countdown = Math.floor(Math.random() * (max - min + 1)) + min //含最大值，含最小值
      this.sendCode()
    },

    sendCode() {
      this.contdown() //启动定时器
      this.timer = setInterval(() => {
        //创建定时器
        if (this.countdown === 1) {
          this.countdown = ''
          this.clearTimer() //关闭定时器
          this.diasbled_btn = false
        } else {
          this.contdown()
        }
      }, 1000)
    },

    contdown() {
      this.countdown--
    },
    clearTimer() {
      //清除定时器
      clearInterval(this.timer)
      this.timer = null
    },
    close() {
      this.clearTimer()
    },

    toAnswer(type) {
      let _this = this
      let id = this.$route.params.id
      let url
      if (type) {
        url = 'paper/penStart/'
      } else {
        url = 'paper/cover/'
      }
      // if (this.Storage.getStorage(this.$route.params.id)) {
      //   this.dialogSubmit = true
      // }
      _this.$http
        .get(process.env.VUE_APP_URL + url + id)
        .then(function(data) {
          _this.loading = false
          if (data.data.code == 403) {
            _this.$message.error(data.data.msg)
            return
          }
          if (data.data.code == 200) {
            // if (type == 'exam') {
            _this.link(type, id)
            // }
            _this.data = data.data.data
            if (_this.data.type == 5 && !!data.data.son) {
              _this.data.num = data.data.son.num
              _this.data.score = data.data.son.score
            }

            _this.data.weekly = _this.weeks[_this.data.weekly]
            if (_this.data.is_pay == 0 && _this.data.pay > 0) {
              _this.payShow = true
            }
            _this.is_repeat = data.data.data.is_repeat
            _this.Storage.setStorage('ai', _this.data.ai)
          } else if (data.data.code == 402) {
            if (data.data.data) {
              let url = window.location.href
              if (url.indexOf('netclass') != -1) {
                window.location.href =
                  'http://netclass.cn/login?url=' + btoa(url)
              } else {
                window.location.href =
                  'http://custom.netban.cn/app/login.html?id=' +
                  data.data.data +
                  '&url=' +
                  btoa(url)
              }
            } else {
              _this.$message.warning('权限不足，不能答题！')
            }
          } else if (data.data.code == 500) {
            _this.dialogVisible = true
          } else {
            _this.data = data.data.data
            _this.data.weekly = _this.weeks[_this.data.weekly]
            _this.disabled = true
            _this.$message.error(data.data.msg)
            this.loading = false
          }
        })
        .catch(function(error) {
          _this.loading = false
          // _this.$message.error({ message: "网络错误,请刷新界面重试" });
          return
        })
    },
    link(name, id) {
      if (this.data.notice == 1) {
        this.getRandomIntInclusive(5, 10)
        this.dialogExam = true
        this.diasbled_btn = true
      } else {
        let params = {
          id: id,
          is_repeat: this.is_repeat,
        }
        this.$router.push({ name, params: { id, is_repeat: this.is_repeat } })
      }
    },
    toVerify(name, id) {
      let _this = this
      // if (!_this.personalInfo.name) {
      //   _this.$message.error('请输入考生姓名')
      //   return
      // }
      // if (!_this.personalInfo.mobile) {
      //   _this.$message.error('请输入考生手机号码')
      //   return
      // }
      // _this.personalInfo.id = id
      // _this.$http
      //   .post(
      //     process.env.VUE_APP_URL + 'verification_user',
      //     _this.personalInfo
      //   )
      //   .then(function(data) {
      //     _this.loading = false
      //     if (data.data.code == 500) {
      //       _this.dialogExam = false
      //       setTimeout(() => {
      //         _this.dialogAccount = true
      //       }, 500)
      //       _this.account = data.data.auth
      //       _this.account.mem_phone = _this.account.mem_phone.replace(
      //         /(\d{3})\d{4}(\d{4})/,
      //         '$1****$2'
      //       )
      //     }
      //     if (data.data.code == 200) {
      _this.$router.push({
        name,
        params: { id, is_repeat: _this.is_repeat },
      })
      //   }
      //   if (data.data.code == 404) {
      //     _this.dialogExam = false
      //     setTimeout(() => {
      //       _this.dialogAccount = true
      //     }, 500)
      //     _this.account = data.data.data
      //     _this.account.mem_phone = _this.account.mem_phone.replace(
      //       /(\d{3})\d{4}(\d{4})/,
      //       '$1****$2'
      //     )
      //   }
      // })
      // .catch(function(error) {
      //   _this.loading = false
      //   // _this.$message.error({ message: "网络错误,请刷新界面重试" });
      //   return
      // })
    },
    clearInfo() {
      this.dialogAccount = false
      this.personalInfo = {}
    },
    toLogin() {
      let jid = this.getCookie('jid')
      // window.open('http://custom.netban.cn/app/login.html')
      let url = window.location.href
      if (url.indexOf('netclass') != -1) {
        window.location.href = 'http://netclass.cn/login?url=' + btoa(url)
      } else {
        window.location.href =
          'http://custom.netban.cn/app/login.html?id=' +
          jid +
          '&url=' +
          btoa(url)
      }
    },
    toPay() {
      let _this = this
      let subsystem_url = window.location.href
      _this.$http
        .post(process.env.VUE_APP_URL + 'paper/pay', {
          paper_id: this.$route.params.id,
          subsystem_url: subsystem_url,
        })
        .then(data => {
          if (data.data.code == 200) {
            //未付款
            _this.order_number = data.data.data
            window.location.href =
              'http://pay.netban.cn/pay/' + this.order_number //跳转至支付页面
          } else {
            _this.$message.error(data.data.msg)
          }
        })
        .catch(err => {
          _this.$message.error('网络错误，请重试')
          console.log(err)
        })
    },
    logout() {
      this.$router.push({ path: '/simulation' })
    },
    out() {
      this.$router.push({ path: '/examination' })
    },
  },
}
</script>
<style lang="less" scope>
.entrance {
  background: url('../../../admin/assets/images/result-bg.jpg') no-repeat;
  background-size: cover;
  max-width: 1000px;
  margin: 0 auto;
  .cont {
    border-radius: 5px;
    padding: 30px 20px 40px 20px;
    .head-cont {
      // height: 230px;
      .head-pic {
        width: 100%;
        // height: 100%;
      }
    }

    .cont-msg {
      background-color: #fff;
      text-align: center;
      font-size: 16px;
      color: #3a3a3a;
      padding: 25px 0;
      .cont-title {
        font-size: 22px;
        margin: 0;
        color: #000;
      }
      p {
        margin: 0;
        padding: 14px 0;
      }
      .start {
        padding-bottom: 0;
      }
    }
  }
  .examKnow {
    font-size: 16px;
    margin-bottom: 30px;
    padding-left: 7px;
    line-height: 25px;
  }
  .el-input {
    width: 250px;
  }

  .el-form {
    padding-left: 170px;
  }
}
.el-button + .el-button {
  margin-left: 80px;
}
.mem_name {
  padding-left: 30px;
}
</style>
